import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'app-page-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslocoModule],
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.scss']
})
export class PageFooterComponent {
  @Input() showAppDownload: boolean = true;

  currentYear = new Date().getFullYear();

  protected readonly appStoreLink = 'https://apps.apple.com/app/questatlas/id6461825089';
  protected readonly playStoreLink = 'https://play.google.com/store/apps/details?id=world.app.questatlas';
  protected readonly threadsLink = 'https://www.threads.net/@questatlas';
  protected readonly instagramLink = 'https://www.instagram.com/questatlas';
  protected readonly websiteLink = 'https://questatlas.world';
  protected readonly contactEmail = 'contact.questatlas@gmail.com';
}

